/* (c) Copyright Frontify Ltd., all rights reserved. */

export const ALIGN_PLUGIN = 'align-plugin';
